<template>
  <section class="section--pd section--pb-xlg">
    <div class="inner">
      <div class="introduce__banner">
        <a href="/introduction">
          <img
            src="assets/img/campaign_introduce.png"
            alt="campaign introduce"
          >
        </a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'CampaignIntroduce'
}
</script>
